module.exports = __webpack_public_path__ + "img/default-loading-error.6138e3cf.jpg";